import { makeAutoObservable } from 'mobx';

export default class SegmentedButtonsStore {
    buttons: ISegmentedButtonsSetup<any> | null = null;
    isTabSwitchDisabled: boolean = false;

    constructor() {
        makeAutoObservable(this);
    }

    setButtons<T>(value: ISegmentedButtonsSetup<T> | null) {
        this.buttons = value;
    }

    setIsTabSwitchDisabled(value: boolean) {
        this.isTabSwitchDisabled = value;
    }

    switchButton(back: boolean) {
        if (!this.buttons || this.isTabSwitchDisabled)
            return;

        const values = [...this.buttons.values];
        if (back)
            values.reverse();

        const nextValueIndex = values.indexOf(this.buttons.value) + 1;
        const nextValue = nextValueIndex < values.length ? values[nextValueIndex] : values[0];
        this.buttons.value = nextValue;
        this.buttons.onChange(nextValue);
    }

    clear() {
        this.setButtons(null);
    }
}

interface ISegmentedButtonsSetup<T> {
    value: T;
    values: T[];
    onChange: (value: T) => void;
}